import { useRef, ReactNode } from "react";

import Button from "components/v2/Button/Button";

import { ATTACHMENT_ACCEPT_TYPES } from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/FileUploadTrigger/attachmentConstants";

interface FileUploadTriggerProps {
  label: string;
  iconLeft: ReactNode;
  multiple?: boolean;
  disabled?: boolean;
  testId?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function FileUploadTrigger({
  label,
  iconLeft,
  multiple,
  disabled,
  testId,
  onChange,
}: FileUploadTriggerProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        variant="secondary-color"
        size="sm"
        iconLeft={iconLeft}
        label={label}
        disabled={disabled}
        className="upload-freight-docs__upload-btn"
        onClick={() => inputRef.current?.click()}
      />
      <input
        ref={inputRef}
        type="file"
        accept={ATTACHMENT_ACCEPT_TYPES}
        style={{ display: "none" }}
        multiple={multiple}
        disabled={disabled}
        data-testid={testId}
        onChange={onChange}
      />
    </>
  );
}
